import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Message } from 'semantic-ui-react'

import MatchesTable from './calendar/MatchesTable'
import RoundSelector from './calendar/RoundSelector'

import './Calendar.css'

class Calendar extends PureComponent {
  render() {
    const {
      highlightedMatches,
      highlightedTeams,
      onRoundChange,
      printable,
      round,
      tournament: {
        relevant_teams: relevantTeams,
        tournament: { stages },
      },
      widget,
    } = this.props

    if (stages?.length && round) {
      const teams = {}
      relevantTeams.forEach((team) => {
        teams[team.id] = team
      })

      return (
        <div className={`SoccerCalendar ${printable ? ' printable' : ''}`}>
          <RoundSelector onChange={onRoundChange} printable={printable} round={round} stages={stages} />
          <MatchesTable
            highlightedMatches={highlightedMatches}
            highlightedTeams={highlightedTeams}
            printable={printable}
            round={round}
            teams={teams}
            widget={widget}
          />
        </div>
      )
    }

    return (
      <Message className="SoccerCalendar__message" color="yellow" size="mini">
        Torneo sin información de Fases.
      </Message>
    )
  }
}

Calendar.propTypes = {
  tournament: PropTypes.object.isRequired,

  highlightedMatches: PropTypes.array,
  highlightedTeams: PropTypes.array,
  onRoundChange: PropTypes.func,
  printable: PropTypes.bool,
  round: PropTypes.object,
  widget: PropTypes.bool,
}

Calendar.defaultProps = {
  highlightedMatches: [],
  highlightedTeams: [],
  onRoundChange: Function.prototype,
  printable: false,
  round: null,
  widget: false,
}

export default Calendar
